<template>
  <div class="drone-view" ref="scrollPage">
    <el-card style="border: none; height: 100%" v-if="boxList.length">
      <div class="monitor-list">
        <div class="btn" @click="scrollLeft" style="margin-left: 5px">
          <i class="el-icon el-icon-arrow-left" />
        </div>
        <div id="list-box" class="list-box">
          <div id="list" class="list">
            <div
              v-for="(item, index) in boxList"
              :key="index"
              class="list-item"
              :class="[
                colors[deviceSNMap[item.sn].state] || colors['-1'],
                currentIndex === index ? 'active' : ''
              ]"
              @click="$emit('subDetail', item, index)"
            >
              <img
                class="drone-icon"
                src="https://img0.baidu.com/it/u=1635688448,2861490248&fm=253&fmt=auto&app=138&f=PNG?w=500&h=500"
                alt=""
              />
              <!-- :class="item.newInfo.state | stateClass(true)" -->
              <div class="device-name" v-if="item.length < 4">{{ item.name }}</div>

              <el-tooltip
                v-else
                class="item"
                effect="dark"
                :content="item.name"
                placement="top-start"
              >
                <div class="device-name">{{ item.name.substr(0, 4) + '..' }}</div>
              </el-tooltip>
            </div>
          </div>
        </div>
        <div class="btn" @click="scrollRight">
          <i class="el-icon el-icon-arrow-right" />
        </div>
      </div>
    </el-card>

    <div class="loading-box" v-else>
      <div style="margin-left: 10px">暂无数据...</div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  props: {
    currentIndex: {
      type: Number
    },
    boxList: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    ...mapState('socket', ['deviceSNMap'])
  },
  data() {
    return {
      isUnfold: true,
      colors: {
        '-1': 'unconnect-color',
        0: 'success-color',
        1: 'warning-color',
        2: 'danger-color',
        61: 'fix-color',
        71: 'fault-color',
        81: 'collect-color'
      },
      themeColor: 'var(success-color)'
    };
  },

  methods: {
    // 左滑动逻辑
    scrollLeft() {
      const allLength = this.boxList.length * 120;
      const boxLength = document.getElementById('list-box').clientWidth;
      if (allLength < boxLength) return;
      const listEl = document.getElementById('list');
      const leftMove = Math.abs(parseInt(window.getComputedStyle(listEl, null)?.left));
      if (leftMove + boxLength - 360 < boxLength) {
        // 到最开始的时候
        listEl.style.left = '0px';
      } else {
        listEl.style.left = '-' + (leftMove - 360) + 'px';
      }
    },
    // 右滑动逻辑
    scrollRight() {
      const allLength = this.boxList.length * 120;
      const boxLength = document.getElementById('list-box').clientWidth;
      if (allLength < boxLength) return;
      const listEl = document.getElementById('list');
      const leftMove = Math.abs(parseInt(window.getComputedStyle(listEl, null)?.left));
      if (leftMove + boxLength + 360 > allLength) {
        listEl.style.left = '-' + (allLength - boxLength) + 'px';
      } else {
        listEl.style.left = '-' + (leftMove + 360) + 'px';
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.drone-view {
  height: 100%;
  width: 100%;

  ::v-deep .el-card {
    background-color: transparent !important;
  }
  ::v-deep .el-card__body {
    padding: 0 !important;
    height: 100%;
  }
  .monitor-list {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;

    .btn {
      width: 30px;
      height: 30px;
      line-height: 30px;
      border-radius: 50%;
      text-align: center;
      cursor: pointer;
      background-color: rgba(27, 171, 253, 0.5);
      color: var(--drone-list-arrow-font-color);
      font-size: 12px;
    }
    .list-box {
      width: calc(100% - 100px);
      overflow: hidden;

      .list {
        width: 100%;
        display: flex;
        transform: all 2s;
      }

      .list {
        .list-item {
          pointer-events: all;
          @include state-bgstyle;
          color: var(--drone-list-base-font-color);
          text-overflow: ellipsis;
          width: 55px;
          height: 55px;
          min-width: 55px;
          border-radius: 50%;
          text-align: center;
          padding: 10px;
          cursor: pointer;
          margin-left: 40px;
          .drone-icon {
            height: 30px;
            width: 30px;
          }
          .device-name {
            font-size: 11px;
          }
        }

        position: relative;
        left: 0;
        transition: left 1s;
      }
      .active {
        border: 2px solid #047eba;
      }
    }
  }

  .loading-box {
    height: 100%;
    color: var(--drone-list-base-font-color);
    text-align: center;
  }
}
</style>
